import React from "react";
import { useCanvasByContext } from "../../store/hook";
import styles from "./index.less";
import { isImageComponent } from "../Left";
import { defaultCommonStyle } from "../../utils/constant";

const defaultStyle = {
  ...defaultCommonStyle,
};

const settings = [
  {
    value:
      "https://typora-licodeao.oss-cn-guangzhou.aliyuncs.com/typoraImg/hove.webp",
    style: defaultStyle,
  },
  {
    value:
      "https://typora-licodeao.oss-cn-guangzhou.aliyuncs.com/typoraImg/new.webp",
    style: defaultStyle,
  },
  {
    value:
      "https://typora-licodeao.oss-cn-guangzhou.aliyuncs.com/typoraImg/birk.webp",
    style: defaultStyle,
  },
  {
    value:
      "https://typora-licodeao.oss-cn-guangzhou.aliyuncs.com/typoraImg/cardiff.webp",
    style: defaultStyle,
  },
  {
    value:
      "https://typora-licodeao.oss-cn-guangzhou.aliyuncs.com/typoraImg/york.webp",
    style: defaultStyle,
  },
  {
    value:
      "https://typora-licodeao.oss-cn-guangzhou.aliyuncs.com/typoraImg/livepool.webp",
    style: defaultStyle,
  },
];

const arithmetic = ["fairytale.webp"];

arithmetic.forEach((item) => {
  settings.push({
    value: `https://commom.pek3b.qingstor.com/all/arithmetic/${
      item.indexOf(".") > 0 ? item : item + ".png"
    }`,
    style: defaultStyle,
  });
});

export default function ImageSide() {
  const canvas = useCanvasByContext();

  const addCmp = (_cmp) => {
    canvas.addCmps(_cmp);
  };

  const onDragStart = (e, _cmp) => {
    e.dataTransfer.setData("data-cmp", JSON.stringify(_cmp));
  };

  return (
    <div className={styles.main}>
      <ul className={styles.box}>
        {settings.map((item) => (
          <li
            key={item.value}
            onClick={() => addCmp({ ...item, type: isImageComponent })}
            className={styles.item}
            onDragStart={(e) =>
              onDragStart(e, { ...item.style, type: isImageComponent })
            }
          >
            <img src={item.value} alt="" />
          </li>
        ))}
      </ul>
    </div>
  );
}
